import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Gala Dinner Invitation section for FAQ Page
 */
const GalaDinnerInvitationSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="gala-dinner-invitation-section-component"
    >
      <AccordionV2
        testId="gala-dinner-invitation"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="How do I get invited to the Gala Dinner?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            Winners will be invited to attend the gala dinner to receive their
            awards. The organisers will usually invite recent past winners and
            other guests to the event.
          </p>

          <p>
            Companies, whether they win or not, are encouraged to buy tables to
            partake in the evening celebrations and fun.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default GalaDinnerInvitationSection;
